import BaseElement from './BaseElement'
import { WishlistItem } from '../components/WishlistItem';

export default class WishlistItemElement extends BaseElement {
  static get observedAttributes () {
    return ['product-id', 'product-handle', 'product-template', 'data-product']
  }

  renderElement () {
    const productId = parseInt(this.getAttribute('product-id') as string)
    const productHandle = this.getAttribute('product-handle')
    const productTemplate = this.getAttribute('product-template')
    this.rootElement.render(<WishlistItem productId={productId} productHandle={productHandle} productTemplate={productTemplate} />)
  }
}
